import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 外部ETサイト - エントリーアカウント一覧取得
export async function getOutsideEntrySiteAccounts(id: string) {
  try {
    const path = "outsideEntrySiteAccounts";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
